import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { intakeNormalize } from "@/lib/intakeNormalize";
import {
  HttpResponse,
  JobIntakeWithCompletion,
  UpdateJobIntakeRequest,
} from "@/types";

export function useUpdateSetJobIntake() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      updateJobIntakeRequest,
    }: {
      updateJobIntakeRequest: UpdateJobIntakeRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-intake`;
      const res = await guacHttpClient.patch<
        JobIntakeWithCompletion,
        HttpResponse<JobIntakeWithCompletion>,
        UpdateJobIntakeRequest
      >(path, updateJobIntakeRequest);
      return { ...res.data, jobIntake: intakeNormalize.job(res.data.jobIntake) };
    },
    onSuccess: (data) => {
      // Invalidate queries that have job intake
      queryClient.setQueryData(
        ["job-intake", currentCompanyId, currentJobId],
        data,
      );

      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
    },
  });
}
